<template>
	<div ref="map" style="width: 100%; height: 100%;"></div>
</template>

<script>
import { MapService, Variables } from 'InterfaceBundle'

export default {
	name: 'BlMap',
	emit: ['ready'],
	props: {
		autoTheme: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			map: null,
			darkStyle: [{'elementType': 'geometry','stylers': [{'color': '#242f3e'}]},{'elementType': 'labels.text.fill','stylers': [{'color': '#746855'}]},{'elementType': 'labels.text.stroke','stylers': [{'color': '#242f3e'}]},{'featureType': 'administrative.locality','elementType': 'labels.text.fill','stylers': [{'color': '#d59563'}]},{'featureType': 'poi','elementType': 'labels.text.fill','stylers': [{'color': '#d59563'}]},{'featureType': 'poi.attraction','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.business','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.government','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.medical','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.park','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.park','elementType': 'geometry','stylers': [{'color': '#263c3f'}]},{'featureType': 'poi.park','elementType': 'labels.text.fill','stylers': [{'color': '#6b9a76'}]},{'featureType': 'poi.place_of_worship','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.school','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.sports_complex','stylers': [{'visibility': 'off'}]},{'featureType': 'road','elementType': 'geometry','stylers': [{'color': '#38414e'}]},{'featureType': 'road','elementType': 'geometry.stroke','stylers': [{'color': '#212a37'}]},{'featureType': 'road','elementType': 'labels.text.fill','stylers': [{'color': '#9ca5b3'}]},{'featureType': 'road.highway','elementType': 'geometry','stylers': [{'color': '#746855'}]},{'featureType': 'road.highway','elementType': 'geometry.stroke','stylers': [{'color': '#1f2835'}]},{'featureType': 'road.highway','elementType': 'labels.text.fill','stylers': [{'color': '#f3d19c'}]},{'featureType': 'transit','elementType': 'geometry','stylers': [{'color': '#2f3948'}]},{'featureType': 'transit.station','elementType': 'labels.text.fill','stylers': [{'color': '#d59563'}]},{'featureType': 'water','elementType': 'geometry','stylers': [{'color': '#17263c'}]},{'featureType': 'water','elementType': 'labels.text.fill','stylers': [{'color': '#515c6d'}]},{'featureType': 'water','elementType': 'labels.text.stroke','stylers': [{'color': '#17263c'}]}],
			lightStyle: [{'featureType': 'poi.attraction','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.business','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.government','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.medical','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.park','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.place_of_worship','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.school','stylers': [{'visibility': 'off'}]},{'featureType': 'poi.sports_complex','stylers': [{'visibility': 'off'}]}]
		}
	},
	created() {
		MapService.load().once(() => {
			this.map = new window.google.maps.Map(this.$refs.map, {
				center: { lat: 49.1996583, lng: -0.3598969 },
				zoom: 20,
				disableDefaultUI: true
			})
			this.$emit('ready', this.map)
			if(this.autoTheme) this.map.setOptions({styles: Variables.theme == 'dark' ? this.darkStyle : this.lightStyle})
		})
	}
}
</script>

<style scoped lang="scss">
	:deep .gm-style > div > div > a {
		display: none !important;
	}

	:deep .gm-style > div:last-child {
		display: none;
	}
</style>